
<template>
  <div>
    <modal v-if="openModal" @close="closeModal()">
      <template v-slot:title>
      {{ $t('terms_and_conditions_modal_title') }}
      </template>
      <template v-slot:body>
        <div class="termsAndCond">
          <div class="termsAndCond__Icon">
            <i class="fas fa-exclamation-triangle" />
          </div>
          <div class="termsAndCond__Body">
            <div class="termsAndCond__title">
              {{ $t('terms_and_conditions_modal_text') }}
            </div>
            <div class="termsAndCond__text">
              <input
                v-model="checkTerms"
                type="checkbox"
                class="termsAndCondForm__termsInput"
                id="termsAndCondForm__termsInput"
                @click="change()"
              >
              <div class="termsAndCondForm__termsWrapper">
                  <label class="termsAndCondForm__termsCheck"
                          for="termsAndCondForm__termsInput">
                    <i class="fas fa-check"></i>
                  </label>
                  <span class="termsAndCondForm__termsContent">
                    <span class="termsAndCondForm__termsText">{{ $t('terms_text')}}</span>
                    <span class="termsAndCondForm__termsLink"
                      @click="goTerms"
                    >
                        {{ $t('terms_link') }}
                    </span>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button @click="acceptTerms()" class="btn termsAndCondForm__continue" :disabled="!checkTerms" >
          {{ $t('continue') }}
          <i class="fas fa-arrow-right mr-2"></i>
        </button>
      </template>
      </modal>
    </div>
</template>

<script>
import Modal from 'core-lib/components/modal/Modal.vue'
export default {
  name: 'TermsAndCondModal',
  components: {
    Modal
  },
  props: {
    value: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      openModal: false,
      checkTerms: this.value
    }
  },
  methods: {
    showModal () {
      this.openModal = true
    },
    goTerms () {
      this.openModal = false
      this.$emit('onGoTerms')
    },
    acceptTerms () {
      this.openModal = false
      this.$emit('onAcceptTerms')
    },
    closeModal () {
      this.checkTerms = false
      this.openModal = false
    },
    change () {
      this.checkTerms = !this.checkTerms
      this.$emit('input', this.checkTerms)
    }
  }
}
</script>
<style lang="sass" scoped>

.termsAndCond
  display: flex
  padding: 1rem
  gap: 1rem
  &__Icon
    min-width: 120px
    background: transparent
    justify-content: center
    align-items: center
    display: flex
    font-size: 48px
    flex-direction: column
    height: auto
    color: var(--color-warning)
  &__Body
    line-height: auto
    display: flex
    flex-direction: column
    gap: .25rem
    justify-content: center
  &__title
    font-weight: 700
    font-size: var(--font-size-base)
    color: var(--color-onSurface)
  &__text
    font-weight: 400
    font-size: var(--font-size-base)
    color: var(--color-onSurface)

.termsAndCondForm
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  height: 3.5rem
  z-index: 1000
  background-color: var(--color-nav)
  color: var(--color-onNav)
  padding: 0 1rem
  display: flex
  align-items: center
  border-top: 1px solid var(--color-overlay-10)
  justify-content: flex-end
  box-shadow: 0 5px 10px 5px var(--color-overlay-10)
  transition: all .2s ease
  .btn
    height: 2.5rem
    text-align: center
  &__continue.btn
    color: var(--surface-onSurface)
    border: 1px solid var(--color-overlay-20)
    background-color: var(--color-overlay-15)
  &__terms
    display: flex
    align-items: center
    justify-content: flex-center
    position: absolute
    bottom: 3.5rem
    right: 0
    width: 100%
    background-color: var(--color-nav)
    color: var(--color-onNav)
    &Wrapper
      display: flex
      width: 100%
      align-items: center
      margin: 0
      padding: 1rem 0
      font-size: var(--font-size-sm)
    &Text
      flex: 1
      text-align: left
      text-wrap: wrap
    &Input
      position: absolute
      opacity: 0
      height: 0
      width: 0
      z-index: -1
      pointer-events: none
      &:checked~.termsAndCondForm__termsWrapper
        .termsAndCondForm__termsCheck
          background-color: var(--color-primary)
          animation: none
          i
            opacity: 1
            color: var(--color-onPrimary)
            transform: scale(1)
    &Check
      height: 1.5rem
      width: 1.5rem
      min-width: 1.5rem
      background-color: var(--color-surface)
      display: flex
      border: 2px solid var(--color-overlay-50)
      border-radius: var(--b-radius-sm)
      margin: 0
      align-items: center
      cursor: pointer
      justify-content: center
      transition: border .3s ease, background-color .3s ease
      animation: pulse 2s infinite
      i
        transition: opacity .3s ease, color .3s ease, transform 0.3s ease
        opacity: 0
        transform: scale(2)
    &Link
      position: relative
      z-index: 1000
      border-bottom: 1px dotted
      font-weight: bolder
      cursor: pointer
      &:hover
        border-bottom: 1px solid
    &Content
      display: flex
      align-items: flex-start
      flex-direction: column
      padding-left: 1rem
@media (max-width: 420px)
  .termsAndCond
    padding: 1rem
    &__Icon
      min-width: 20px
      font-size: 24px
      height: auto
      color: var(--color-warning)
      justify-content: start
      gap: .25rem
      margin-top: 0.5rem

@media (min-width: 768px)
  .termsAndCondForm
    &__terms
      background-color: transparent
      position: initial
      &Check
        height: 1.75rem
        width: 1.75rem
        min-width: 1.75rem
      &Wrapper
        background-color: transparent
  .--summary-active
    .termsAndCondForm
      transform: none
@media (min-width: 1200px)
  .termsAndCondForm
    z-index: 10000
</style>
